/**
 * Landing Page Footer & SEO Section
 * ZO Bull Algo Trading Platform
 */
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const FOOTER_LINKS = {
  product: {
    titleKey: 'product',
    links: [
      { labelKey: 'features', href: '#features' },
      { labelKey: 'pricing', href: '#pricing' },
      { labelKey: 'marketplace', href: '/marketplace' },
      { labelKey: 'api', href: '/api-docs' },
      { labelKey: 'login', href: '/login' },
      { labelKey: 'register', href: '/register' }
    ]
  },
  company: {
    titleKey: 'company',
    links: [
      { labelKey: 'about', href: '/about' },
      { labelKey: 'blog', href: '/blog' },
      { labelKey: 'careers', href: '/careers' },
      { labelKey: 'contact', href: '/contact' }
    ]
  },
  resources: {
    titleKey: 'resources',
    links: [
      { labelKey: 'documentation', href: '/docs' },
      { labelKey: 'userGuide', href: '/docs/user-guide' },
      { labelKey: 'apiReference', href: '/docs/api' },
      { labelKey: 'support', href: '/support' },
      { labelKey: 'tutorials', href: '/tutorials' }
    ]
  },
  legal: {
    titleKey: 'legal',
    links: [
      { labelKey: 'terms', href: '/legal/terms' },
      { labelKey: 'privacy', href: '/legal/privacy' },
      { labelKey: 'disclaimer', href: '/legal/disclaimer' },
      { labelKey: 'refundPolicy', href: '/legal/refund' }
    ]
  },
  account: {
    titleKey: 'account',
    links: [
      { labelKey: 'login', href: '/login' },
      { labelKey: 'registerFree', href: '/register' },
      { labelKey: 'forgotPassword', href: '/register' },
      { labelKey: 'pricing', href: '#pricing' }
    ]
  }
}

const SOCIAL_LINKS = [
  { icon: '🐦', label: 'Twitter', href: 'https://twitter.com/zobull' },
  { icon: '💼', label: 'LinkedIn', href: 'https://linkedin.com/company/zobull' },
  { icon: '📱', label: 'Telegram', href: 'https://t.me/zobull' },
  { icon: '💬', label: 'Discord', href: 'https://discord.gg/zobull' },
  { icon: '📺', label: 'YouTube', href: 'https://youtube.com/@zobull' }
]

export default function LandingFooter() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className="landing-footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logo.png" alt="ZO Bull Logo" className="logo-image" />
              <span className="logo-text">ZO Bull</span>
            </div>
            <p className="footer-tagline">
              {t('landing.footerTagline')}
            </p>
            <div className="footer-social">
              {SOCIAL_LINKS.map((social, index) => (
                <a 
                  key={index} 
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
          
          <div className="footer-links">
            {Object.entries(FOOTER_LINKS).map(([key, section]) => (
              <div key={key} className="footer-section">
                <h4 className="footer-section-title">{t(`landing.${section.titleKey}`)}</h4>
                <ul className="footer-section-links">
                  {section.links.map((link, index) => (
                    <li key={index}>
                      <Link to={link.href}>{t(`landing.${link.labelKey}`)}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-copyright">
            <p>{t('landing.copyright').replace('2024', String(currentYear))}</p>
            <p className="footer-disclaimer">
              {t('landing.footerDisclaimer')}
            </p>
          </div>
          <div className="footer-badges">
            <span className="footer-badge">🔒 {t('landing.sslSecured')}</span>
            <span className="footer-badge">⚡ {t('landing.uptime')}</span>
            <span className="footer-badge">🌍 {t('landing.globalCoverage')}</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
